import { ColumnsType } from 'antd/es/table';
import { CyberHubItApplicationSummary } from '../types/reports';
import { tableSortingMethods } from '../../../utils';
import { CompletionPercentage } from '../../cyber/components';

export const columns = (
  entity: 'Qualitative Factor' | 'Process Area' | 'Business Function',
): ColumnsType<CyberHubItApplicationSummary> => [
  {
    title: entity,
    dataIndex: 'name',
    key: 'name',
    defaultSortOrder: 'ascend',
    sorter: (
      a: CyberHubItApplicationSummary,
      b: CyberHubItApplicationSummary,
    ) => tableSortingMethods.string(a.name, b.name),
  },
  {
    title: '# of Applications',
    dataIndex: 'totalTaggedApplications',
    key: 'totalTaggedApplications',
    width: 200,
    align: 'center',
    sorter: (
      a: CyberHubItApplicationSummary,
      b: CyberHubItApplicationSummary,
    ) =>
      tableSortingMethods.number(
        a.totalTaggedApplications,
        b.totalTaggedApplications,
      ),
  },
  {
    title: 'Workaround Completion',
    dataIndex: 'completionPercentage',
    key: 'completionPercentage',
    width: 250,
    align: 'center',
    sorter: (
      a: CyberHubItApplicationSummary,
      b: CyberHubItApplicationSummary,
    ) =>
      tableSortingMethods.number(
        a.completionPercentage,
        b.completionPercentage,
      ),
    render: (completion: number) => (
      <CompletionPercentage percent={completion} colorize />
    ),
  },
  {
    title: 'SLA',
    dataIndex: 'workaroundCompliancePercentage',
    key: 'workaroundCompliancePercentage.sla',
    width: 100,
    align: 'center',
    sorter: (
      a: CyberHubItApplicationSummary,
      b: CyberHubItApplicationSummary,
    ) =>
      tableSortingMethods.number(
        a.workaroundCompliancePercentage.sla,
        b.workaroundCompliancePercentage.sla,
      ),
    render: (
      percentage: CyberHubItApplicationSummary['workaroundCompliancePercentage'],
    ) => <CompletionPercentage percent={percentage.sla} colorize />,
  },
  {
    title: 'RTO',
    dataIndex: 'workaroundCompliancePercentage',
    key: 'workaroundCompliancePercentage.rto',
    width: 100,
    align: 'center',
    sorter: (
      a: CyberHubItApplicationSummary,
      b: CyberHubItApplicationSummary,
    ) =>
      tableSortingMethods.number(
        a.workaroundCompliancePercentage.rto,
        b.workaroundCompliancePercentage.rto,
      ),
    render: (
      percentage: CyberHubItApplicationSummary['workaroundCompliancePercentage'],
    ) => <CompletionPercentage percent={percentage.rto} colorize />,
  },
  {
    title: 'MTO',
    dataIndex: 'workaroundCompliancePercentage',
    key: 'workaroundCompliancePercentage.mto',
    width: 100,
    align: 'center',
    sorter: (
      a: CyberHubItApplicationSummary,
      b: CyberHubItApplicationSummary,
    ) =>
      tableSortingMethods.number(
        a.workaroundCompliancePercentage.mto,
        b.workaroundCompliancePercentage.mto,
      ),
    render: (
      percentage: CyberHubItApplicationSummary['workaroundCompliancePercentage'],
    ) => <CompletionPercentage percent={percentage.mto} colorize />,
  },
  {
    title: 'RPO',
    dataIndex: 'workaroundCompliancePercentage',
    key: 'workaroundCompliancePercentage.rpo',
    width: 100,
    align: 'center',
    sorter: (
      a: CyberHubItApplicationSummary,
      b: CyberHubItApplicationSummary,
    ) =>
      tableSortingMethods.number(
        a.workaroundCompliancePercentage.rpo,
        b.workaroundCompliancePercentage.rpo,
      ),
    render: (
      percentage: CyberHubItApplicationSummary['workaroundCompliancePercentage'],
    ) => <CompletionPercentage percent={percentage.rpo} colorize />,
  },
];
